export const QUESTION_TYPES = {
    NORMAL: 'normal',
    DRAG_AND_DROP: 'dragAndDrop'
}

export const BREAKPOINTS = {

}